<template>
  <!-- htmlファイル側の「<router-view>」内に表示する内容 -->
    <nav>
      <div class="d-grid gap-3 vy-right-nav" >
        
        <p v-on:click="information()" style="cursor:pointer;margin:10px 0" :class="{red_info:!information_kidoku}">
            <template v-if="!information_kidoku">
                <b><u>インフォメーション</u></b>
            </template>
            <template v-else>
                <u>インフォメーション</u>
            </template>
        </p>
        <!--
        <span v-on:click="information()" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow" v-if="isInfoVisible">インフォメーション</span>-->
        <span v-on:click="home()" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow">設定</span>
        <span v-on:click="import_csv()" v-if="shakyouser_gamen[0] == 1" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow">インポート</span>
        <span v-if="jizen_jisshi==1" v-on:click="jizen()"  class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow">事前説明会情報</span>
        <span v-if="jigo_jisshi==1" v-on:click="jigo()"  class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow">事後集会情報</span>
        <span v-on:click="facility()"  class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow">受入先情報</span>
        <span v-on:click="taiken()"  class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow">体験プログラム情報</span>
        <span v-on:click="user()"  class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow">
            <span v-if="cancel == 1 || message == 1" style="color:red"><b>体験ユーザー管理</b></span>
            <span v-else>体験ユーザー管理</span>
        </span>
        
        <span v-on:click="mail()" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow" style="background-color: green;">メール情報</span>
        <span v-on:click="form()"  class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow" style="background-color: green;">アンケート・報告書情報</span>
        <span v-on:click="shomei()" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow" style="background-color: green;">参加証明書情報</span>
        <span v-on:click="syukei_move()" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow" style="background-color: red;" v-if="syukei == true && shakyouser_gamen[21] == 1">集計</span>
        <span v-on:click="csv_out()" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow" style="background-color: red;" v-if="shakyouser_gamen[22] == 1">エクスポート</span>
        <br>
        <span v-if="riyou_visible" v-on:click="riyousya()" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow" style="background-color: orangered;">利用者管理</span>
        <span v-if="checkin_flg==1 && checkin_disp_flg==2" v-on:click="qr_read()" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow" style="background-color: orangered;">二次元コード読取り</span>
        <span v-on:click="open_taikensha()" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow" style="background-color: orangered;">体験者用システム情報</span>
        <!--  ログアウトすると他の端末もログアウトされるので今のところ表示しない
        <p v-on:click="log_out" style="cursor:pointer"><u>ログアウト</u></p>
        -->
        <p v-on:click="inquiry()" style="cursor:pointer;margin-top:10px">
            <u>お問い合わせ</u>
        </p>

        <p v-on:click="Return_kanri" style="cursor:pointer" v-if="kengen == 'master' || kengen == 'Master'">
            <!-- マスターアカウントのみ表示 -->
            <u>さんこう株式会社<br>管理画面</u>
        </p>
      </div>
    </nav>
</template>

<style scoped>

button{
  padding: 0;
}

</style>

<script setup>
/* eslint-disable */
import {
    CognitoUserPool,
    CognitoUser,
    AuthenticationDetails } from 'amazon-cognito-identity-js'
import { useRouter,useRoute } from 'vue-router'
import { GlobalData, login_check, logout } from '../js/userdata_shakyo.js'
import { ref, onMounted, onUnmounted } from 'vue'

import axios from 'axios'

login_check()


let route = useRoute()
// アカウントの権限
let kengen = ref("")

// 集計画面（埼玉県社協のみ）に入れるかどうか
let syukei = ref(false)

  
let cancel = ref(0)
let message = ref(0)

/* 変数の記述 */
let router = useRouter()

// インフォメーションの既読フラグ（trueなら既読）
let information_kidoku = ref(true)

// 利用者管理機能ボタンの利用フラグ（利用者以外は表示）
let riyou_visible = ref(false)

// チェックイン機能の利用フラグ
let checkin_flg = ref(2)

// 事業者二次元コード表示フラグ
let checkin_disp_flg = ref(1)

// お問い合わせの時の社協名
let shakyo_name = ""

const login = function() {
    //document.getElementById("vy_responsive_menu_close").click();
	login_check()
    router.push('/'+GlobalData.shakyo+'/Kanri/MailLogin')
}
const log_out = async () => {
    
    try {
        await axios.post("/dev/logout_lambda", {}, { withCredentials: true });
        //alert("ログアウトしました。");
        GlobalData.$User_email = null
        GlobalData.user_id = null
        GlobalData.kencd = null
        GlobalData.city = null
        GlobalData.kengen = null

        router.push('/'+GlobalData.shakyo+'/Kanri/MailLogin')
    } catch (err) {
        console.error(err);
        alert("ログアウト失敗");
    }
    /*
    let poolData = {
        UserPoolId: GlobalData.$UserPoolId,  // Your user pool id here
        ClientId: GlobalData.$ClientId  // Your client id here
    };
    const userPool = new CognitoUserPool(poolData);
    let cognitoUser = userPool.getCurrentUser();
    if (cognitoUser) {
        // ログアウト
        cognitoUser.signOut();
        GlobalData.$User_email = "";
        //alert("ログアウトしました。");
    }
    GlobalData.$User_email = null
    GlobalData.user_id = null
    GlobalData.kencd = null
    GlobalData.city = null
    GlobalData.kengen = null
    //document.getElementById("vy_responsive_menu_close").click();*/

}


const emit = defineEmits(['form_reset']);

let information = function(){
    search_param_reset()
    router.push('/'+GlobalData.shakyo+'/Kanri/Information')

}
let home = function(){
    search_param_reset()
    router.push('/'+GlobalData.shakyo+'/Kanri')
}
let import_csv = function(){
    search_param_reset()
    
    router.push('/'+GlobalData.shakyo+'/Kanri/Import')
}
let jizen = function(){
    search_param_reset()
    
    router.push('/'+GlobalData.shakyo+'/Kanri/Jizen/list')
}
let taiken = function(){
    search_param_reset()
    
    router.push('/'+GlobalData.shakyo+'/Kanri/Taiken/list')
}

let jigo = function(){
    search_param_reset()
    
    router.push('/'+GlobalData.shakyo+'/Kanri/Jigo/list')
}
let user = function(){
    search_param_reset()
    
    router.push('/'+GlobalData.shakyo+'/Kanri/User/list')
}

let facility = function (){
    search_param_reset()
    router.push('/'+GlobalData.shakyo+'/Kanri/Facility/list')
}

let mail = function(){
    search_param_reset()
    router.push('/'+GlobalData.shakyo+'/Kanri/Mail/list')

}

let shomei = function(){
    search_param_reset()
    
    router.push('/'+GlobalData.shakyo+'/Kanri/Shomei/list')
}

let syukei_move = function(){
    search_param_reset()
    router.push('/'+GlobalData.shakyo+'/Kanri/Syukei')
}

let system = function(){
    search_param_reset()
    
    router.push('/'+GlobalData.shakyo+'/Kanri/System')
}

let form = function(){
    search_param_reset()
    
    router.push('/'+GlobalData.shakyo+'/Kanri/Form/list')
}

let csv_out = function (){
    search_param_reset()
    router.push('/'+GlobalData.shakyo+'/Kanri/CsvOut/Home')
}


let Return_moshikomi = function(){
    
    // ログアウト
    var poolData = {
        UserPoolId : GlobalData.$UserPoolId,
        ClientId : GlobalData.$ClientId
    };
    var userPool = new CognitoUserPool(poolData);
    var cognitoUser = userPool.getCurrentUser();
    if (cognitoUser) {
        // ログアウト
        cognitoUser.signOut();
    }
    
    GlobalData.$User_email = null
    GlobalData.user_id = null
    GlobalData.kencd = null
    GlobalData.city = null
    GlobalData.kengen = null
    
    search_param_reset()
    
    router.push('/'+GlobalData.shakyo+'/Taiken')
}

let Return_kanri = function(){
    router.push('/Sanko')
}

let inquiry = function(){

    const base = "https://docs.google.com/forms/d/e/1FAIpQLSfpddInL8Q2ZlH2RCF8fYf5RZubD0-5Qn39sRcslnLpDFGQNQ/viewform";

    // URLSearchParamsは、URLのパラメータ作成するJavascriptのメソッド　entry.XXXXX は、Googleフォーム項目のリンク 初期値として設定できる
    const params = new URLSearchParams({
            "entry.1449005772": shakyo_name
    });

    const url = `${base}?${params.toString()}`;

    window.open(url, "_blank");

}


let open_taikensha = function(){
   
    emit('call',{cmd:'open_taikensha'});
}

let qr_read = function(){
   
    router.push('/'+GlobalData.shakyo+'/Kanri/Qrread')

}

let riyousya =  function(){
   
    router.push('/'+GlobalData.shakyo+'/Kanri/Multiple/list')

}

let rireki_check_count = 0
/*
let rireki_check = function(){
    let send_array = {"choson_code":GlobalData.choson_code,"cancel":"0"}
  //---------------- 操作履歴を取得
  axios.post(GlobalData.$API_URL+"Rireki_get", send_array,GlobalData.$ID_Token
          ).then(response => {
            if(response.data.rireki_kanri.length != 0){
                cancel.value = 1
            }
  }).catch(error => {
    if(rireki_check_count == 6){
        alert("キャンセル・削除履歴の取得時にエラーが発生しました。"+error)
    }else{
        rireki_check_count++
        setTimeout(function(){rireki_check()},"1000")
    }
  })
}
*/
async function rireki_check() {
    let send_array = {"choson_code":GlobalData.choson_code,"cancel":"0"}
  try {
    const response = await axios.post("/dev/Rireki_get", send_array, { withCredentials: true });

    if(response.data.rireki_kanri.length != 0){
        cancel.value = 1
    }
    
  } catch (err) {
    console.error(err);
    if(rireki_check_count == 6){
        alert("キャンセル・削除履歴の取得時にエラーが発生しました。"+JSON.stringify(err))
    }else{
        rireki_check_count++
        setTimeout(function(){rireki_check()},"1000")
    }
//    alert("保護API呼び出し失敗"+JSON.stringify(err));
  }
}

// 事前・事後の実施フラグを取得
let jizen_jisshi = ref(2)
let jigo_jisshi = ref(2)
let shakyo_error = 0
async function shakyo_read() {
    let send_array = {shakyo:GlobalData.shakyo}
  try {
    const response = await axios.post("/dev/Shakyo_read", send_array, { withCredentials: true });
    jizen_jisshi.value = response.data.jizen_jisshi
    jigo_jisshi.value = response.data.jigo_jisshi
    checkin_flg.value = response.data.checkin_flg
    checkin_disp_flg.value = response.data.checkin_disp_flg
    information_kidoku.value = response.data.information_kidoku

    shakyo_name = response.data.shakyo_name

    console.log(response.data)
    console.log(jizen_jisshi.value)
    console.log(jigo_jisshi.value)

    // 政令都市向けオプション適用済みかどうか
    let designated_city = response.data.designated_city
    if(designated_city){
        
    }
  } catch (err) {
    console.error(err);
    if(shakyo_error == 6){
        alert("事前・事後実施フラグの取得時にエラーが発生しました。"+JSON.stringify(err))
    }else{
        shakyo_error++
        setTimeout(function(){shakyo_read()},"1000")
    }
//    alert("保護API呼び出し失敗"+JSON.stringify(err));
  }
}



let message_check_count = 0
    /*
let message_check = function(){

  //---------------- 操作履歴を取得
  axios.post(GlobalData.$API_URL+"Rireki_get", send_array,GlobalData.$ID_Token
          ).then(response => {
            if(response.data.rireki_kanri.length != 0){
                message.value = 1
            }
  }).catch(error => {
    
    if(message_check_count == 6){
        alert("未読メッセージの取得時にエラーが発生しました。"+error)
    }else{
        message_check_count++
        setTimeout(function(){rireki_check()},"1000")
    }
  })
 
}
  */

  //---------------- メッセージ履歴の件数を取得
async function message_check() {
    let send_array = {"choson_code":GlobalData.choson_code,"rireki_check":0}
  try {
    const response = await axios.post("/dev/Message_rireki_get", send_array, { withCredentials: true });

    if(response.data.message_kanri.length != 0){
        message.value = 1
    }
    
  } catch (err) {
    console.error(err);
    if(message_check_count == 6){
        alert("未読メッセージの取得時にエラーが発生しました。"+JSON.stringify(err))
    }else{
        message_check_count++
        setTimeout(function(){message_check()},"1000")
    }
  }
}

let shakyo_check = function(){
    // 稀にGlobalData.choson_codeがnullの時がありエラー画面になるのでnullチェックを入れた。
    let ken_code = ''
    // 市区町村コードの最初の2文字（県コード部分）を抽出
    if(GlobalData.choson_code != null){
      ken_code = GlobalData.choson_code.substr(0,2)
    }

    // 県コードが11（埼玉）または00（テスト）なら集計ボタンを表示
    if(ken_code == '11' || ken_code == '00'){
        syukei.value = true
    }
}

let Shakyouser_error_count = 0
function shakyouser_check(){
    if(GlobalData.$User_email == null) return
    //---------------- 社協英名から市区町村コードを取得
    axios.post(GlobalData.$API_URL+"Shakyouser_read", 
        {shakyouser_email:GlobalData.$User_email}
        ).then(response => {

        let rt = response["data"] 

        if(rt["status"] != 0){  // 異常終了時の処理
            alert("利用者情報の読み込み時にエラーが発生しました。")
            return
        }
        /*
        if(rt["shakyouser_info"]["shakyouser_id"]){
            isVisible.value = false
        }  else {
            // isVisible.value = true
        }
        */
    }).catch(error => {
        if(Shakyouser_error_count > 5){
            alert("利用者情報の読み込み時にエラーが発生しました。\n"+error)
        }else{
            Shakyouser_error_count++
            shakyouser_check()
        }
        
    })
}

import { useStore } from 'vuex'
const store = useStore()
// 検索条件の初期化
let search_param_reset = function(){
    // store.state.taikenuser = {}
}

/*
以下の機能はボタンを隠すかどうか判断
0	インポート
21	集計
22	エクスポート
*/
let shakyouser_gamen = ref([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0])
setTimeout(function(){
    kengen.value = GlobalData.kengen
    if(kengen.value != "Shakyouser" && kengen.value != "shakyouser"){
        riyou_visible.value = true
    }
    shakyouser_gamen.value  = GlobalData.shakyouser_gamen
    console.log(shakyouser_gamen.value)
    shakyo_check()
    shakyo_read()
},"2000")


setTimeout(function(){
    shakyouser_check()
    rireki_check()
    message_check()
},"2000")


</script>


<style scoped>
.btn-default >.badge-notify{
   background:red;
   position:relative;
   top: 7px;
   left: -62px;
}

.red_info{
    color:red
}
</style>